import type { WatchdogsFeatureConfig } from './type';

export const watchdogs: WatchdogsFeatureConfig = {
    phoneNumberCostWarning: false,
    updateContentType: 'application/json',
    showOverviewDescription: 'never',
    channelSelectionDisclaimer: 'none',
};
